import { Box, Link, Tooltip } from '@cmg/design-system';
import isEmpty from 'lodash/isEmpty';
import React, { useMemo } from 'react';

import routeFactory from '../../../../../../common/util/routeFactory';
import type { FirmMatchRow } from '../../../../../../types/domain/firm-match/FirmMatch';

type Props = {
  data: FirmMatchRow;
  crmIntegrationId: string;
};

export const MappingCellRenderer: React.FC<Props> = ({ data: firmMatch, crmIntegrationId }) => {
  const linkedFirms = React.useMemo(
    () => firmMatch.investorFirmsLinkedToSameCmgEntity ?? [],
    [firmMatch.investorFirmsLinkedToSameCmgEntity]
  );

  const tooltipContent = useMemo(
    () => (
      <Box>
        {linkedFirms.map(firm => (
          <div key={firm.id}>
            <Link
              color="primary"
              href={routeFactory.rolodexCrmEntityMatcher.getUrlPath({
                crmIntegrationId,
                crmInvestorFirmId: firm.id,
              })}
              variant="tooltip"
            >
              {firm.name}
            </Link>
          </div>
        ))}
      </Box>
    ),
    [linkedFirms, crmIntegrationId]
  );

  if (isEmpty(linkedFirms)) {
    return null;
  }

  const count = linkedFirms.length;

  return (
    <Tooltip title={tooltipContent} placement="top" variant="info">
      <div>{count}</div>
    </Tooltip>
  );
};

export default MappingCellRenderer;
